import { render, staticRenderFns } from "./SoilDocxEntry.vue?vue&type=template&id=6f3decab&scoped=true"
import script from "./SoilDocxEntry.vue?vue&type=script&lang=js"
export * from "./SoilDocxEntry.vue?vue&type=script&lang=js"
import style0 from "./SoilDocxEntry.vue?vue&type=style&index=0&id=6f3decab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3decab",
  null
  
)

export default component.exports